import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // },
  {
    path: '/util/codec',
    name: 'BemaniCodec',
    component: () => import('../views/BemaniCodec.vue'),
    props: {
      title: 'Bemani Codec v1.0'
    }
  },
  {
    path: '/util/seqconvert',
    name: 'Sequence Converter',
    component: () => import('../views/SequenceConverter.vue'),
    props: {
      title: 'Sequence Converter v1.0'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
